/* eslint-disable no-unused-vars */
import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import "./styles.css";
import {
  GuestsType,
  DateType,
  formatPrice,
  getFormattedDateTime,
  getFormattedTime,
  getEstateName,
  pick,
  _,
  numSelectedExperiencesGuestsPropType,
  experiencesDatesPropType,
  experiencesTimesPropType,
  experiencesPricesPropType,
  experiencePropType,
  TimeType
} from "../../model/utils";
import ExperienceContent from "../experience-selector/content";
import NumGuests from "./num-guests";
import Summary from "../price/summary";

const Confirmation = ({
  name,
  surname,
  country,
  postcode,
  email,
  phoneNumber,
  numRoomGuests,
  hasRoomKind,
  roomKind,
  roomDates,
  selectedExperiences,
  numSelectedExperiencesGuests,
  experiencesDates,
  experiencesTimes,
  notes,
  roomPrice,
  experiencesPrices,
  hasTable,
  reservationType,
  numTableGuests,
  tableDate,
  tableTime
}) => {
  return (
    <div styleName="container">
      {hasRoomKind && roomKind && (
        <div styleName="entry">
          <div className="row">
            <div className="col-12">
              <div styleName="title">
                {_.stay} {getEstateName()}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="row">
                <div className="col-lg-4 col-12" styleName="label">
                  {_.name}
                </div>
                <div className="col-lg-8 col-12" styleName="value">
                  {name}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-12" styleName="label">
                  {_.surname}
                </div>
                <div className="col-lg-8 col-12" styleName="value">
                  {surname}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-12" styleName="label">
                  {_.country}
                </div>
                <div className="col-lg-8 col-12" styleName="value">
                  {country}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-12" styleName="label">
                  {_.postcode}
                </div>
                <div className="col-lg-8 col-12" styleName="value">
                  {postcode}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-12" styleName="label">
                  {_.email}
                </div>
                <div className="col-lg-8 col-12" styleName="value">
                  {email}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-12" styleName="label">
                  {_.phoneNumber}
                </div>
                <div className="col-lg-8 col-12" styleName="value">
                  {phoneNumber}
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="row">
                <div className="col-lg-4 col-12" styleName="label">
                  {_.date}
                </div>
                <div className="col-lg-8 col-12" styleName="value">
                  {getFormattedDateTime(roomDates)}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-12" styleName="label">
                  {_.roomKind}
                </div>
                <div className="col-lg-8 col-12" styleName="value">
                  {roomKind.title}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-12" styleName="label">
                  {_.numGuests}
                </div>
                <div className="col-lg-8 col-12" styleName="value">
                  <NumGuests numGuests={numRoomGuests} />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-12" styleName="label">
                  {_.stayPrice}
                </div>
                <div className="col-lg-8 col-12" styleName="value strong">
                  {formatPrice(roomPrice)}€
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {(selectedExperiences || []).map(experience => (
        <div key={experience.id} styleName="entry">
          <div className="row">
            <div className="col-12">
              <div styleName="title">{_.experience}</div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div styleName="label">{experience.title}</div>
              <div styleName="experience-content">
                <ExperienceContent experience={experience} />
              </div>
            </div>
            <div className="col-sm-6" styleName="experience-right-col">
              <div className="row">
                <div className="col-lg-4 col-12" styleName="label">
                  {_.experienceDate}
                </div>
                <div className="col-lg-8 col-12" styleName="value">
                  {getFormattedDateTime(
                    experiencesDates[experience.id],
                    experiencesTimes[experience.id]
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-12" styleName="label">
                  {_.numPartecipants}
                </div>
                <div className="col-lg-8 col-12" styleName="value">
                  <NumGuests
                    numGuests={numSelectedExperiencesGuests[experience.id]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-12" styleName="label">
                  {_.experiencePrice}
                </div>
                <div className="col-lg-8 col-12" styleName="value strong">
                  {formatPrice(experiencesPrices[experience.id])}€
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      {(hasTable || reservationType === "table") && (
        <div styleName="entry">
          <div className="row">
            <div className="col-12">
              <div styleName="title">
                {_.table} {getEstateName()}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-12" styleName="label">
              {_.name}
            </div>
            <div className="col-lg-6 col-12" styleName="value">
              {name}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-12" styleName="label">
              {_.surname}
            </div>
            <div className="col-lg-6 col-12" styleName="value">
              {surname}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-12" styleName="label">
              {_.email}
            </div>
            <div className="col-lg-6 col-12" styleName="value">
              {email}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-12" styleName="label">
              {_.phoneNumber}
            </div>
            <div className="col-lg-6 col-12" styleName="value">
              {phoneNumber}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-12" styleName="label">
              {_.numGuests}
            </div>
            <div className="col-lg-6 col-12" styleName="value">
              {numTableGuests}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-12" styleName="label">
              {_.date}
            </div>
            <div className="col-lg-6 col-12" styleName="value">
              {getFormattedDateTime(tableDate)}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-12" styleName="label">
              {_.time}
            </div>
            <div className="col-lg-6 col-12" styleName="value">
              {getFormattedTime(tableTime)}
            </div>
          </div>
        </div>
      )}
      <div styleName="entry summary-wrapper">
        <Summary hidePriceInLowRes={true} />
      </div>
      <div styleName="entry">
        <div className="row">
          <div className="col-lg-3">
            <div styleName="label">{_.specialRequests}</div>
          </div>
          <div className="col-lg-9">
            <textarea styleName="textarea" disabled={true} value={notes} />
          </div>
        </div>
      </div>
    </div>
  );
};

Confirmation.propTypes = {
  name: PropTypes.string,
  surname: PropTypes.string,
  country: PropTypes.string,
  postcode: PropTypes.string,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  numRoomGuests: GuestsType,
  hasRoomKind: PropTypes.bool.isRequired,
  roomKind: PropTypes.object,
  roomDates: DateType,
  selectedExperiences: PropTypes.arrayOf(experiencePropType),
  numSelectedExperiencesGuests: numSelectedExperiencesGuestsPropType,
  experiencesDates: experiencesDatesPropType,
  experiencesTimes: experiencesTimesPropType,
  notes: PropTypes.string,
  roomPrice: PropTypes.number,
  experiencesPrices: experiencesPricesPropType,
  hasTable: PropTypes.bool,
  reservationType: PropTypes.oneOf(["room", "experience", "table"]),
  numTableGuests: PropTypes.number.isRequired,
  tableDate: PropTypes.oneOf([
    PropTypes.string.isRequired,
    PropTypes.objectOf(DateType).isRequired
  ]),
  tableTime: TimeType.isRequired
};

export default connect(
  pick([
    "name",
    "surname",
    "country",
    "postcode",
    "email",
    "phoneNumber",
    "numRoomGuests",
    "hasRoomKind",
    "roomKind",
    "roomDates",
    "selectedExperiences",
    "numSelectedExperiencesGuests",
    "experiencesDates",
    "experiencesTimes",
    "notes",
    "roomPrice",
    "experiencesPrices",
    "hasTable",
    "reservationType",
    "numTableGuests",
    "tableDate",
    "tableTime"
  ])
)(Confirmation);
